"use client";

import { Calendar } from "lucide-react";
import type { Vehicle } from "../../../../types/Vehicle.types";
import { FuelIcon } from "../../../icons/fuel";
import { OdometerIcon } from "../../../icons/odometer";
import { TransmissionIcon } from "../../../icons/transmission";
import { DetailTag } from "./details-tag";
import { ShareButton } from "./share-button";
import { getCookie } from "cookies-next";
import {
  PostHostEventsEnum,
  sendPostHogEvent,
} from "../../../../libs/post-hog/post-hog-send-event";

export const DetailsHeader = ({ vehicle }: { vehicle: Vehicle }) => {
  const isMotorcycle = vehicle.type === "Motorcycle";

  const handleShareEvent = async () => {
    const email = (await getCookie("leadEmail")) ?? undefined;

    sendPostHogEvent({
      eventName: PostHostEventsEnum.SHARE_VEHICLE,
      email: email,
      eventProperties: {
        email: email ? email : undefined,
        ...vehicle,
      },
    });
  };

  return (
    <div className="relative pb-40 sm:pb-0 px-[1rem] md:px-0">
      <div className="pt-10">
        <h1 className="mb-1 text-4xl lg:text-4xl tracking-tighter font-bold relative">
          {isMotorcycle ? vehicle.make : `${vehicle.make} ${vehicle.model}`}
        </h1>
        <span className="text-lg truncate">
          {isMotorcycle ? vehicle.model : vehicle.version}
        </span>
        <div className="flex flex-wrap gap-2.5 mt-5">
          <DetailTag
            icon={<Calendar size={20} strokeWidth={1.5} color="#818cf8" />}
            label={vehicle.modelYear}
          />
          <DetailTag
            icon={
              <OdometerIcon
                strokeWidth={1.5}
                size={20}
                strokeColor="#818cf8"
                fill="#818cf8"
              />
            }
            label={`${new Intl.NumberFormat("pt-BR").format(vehicle.kilometers)} KM`}
          />
          <DetailTag
            icon={
              <TransmissionIcon
                strokeWidth={1.5}
                size={20}
                strokeColor="#818cf8"
              />
            }
            label={
              isMotorcycle
                ? `${vehicle.numberGears} Marchas`
                : vehicle.transmission
            }
          />
          <DetailTag
            icon={
              <FuelIcon
                strokeWidth={1.5}
                size={20}
                strokeColor="#818cf8"
                fill="#818cf8"
              />
            }
            label={vehicle.fuel}
          />
        </div>
      </div>

      <div className="absolute bottom-0 left-[1rem] md:left-0 sm:right-0 text-right">
        <div className="flex items-center sm:justify-end mb-[12px]">
          <div className="flex items-center mr-[18px]">
            <span className="text-[15px] inline-block mr-[10px] font-medium">
              Compartilhar
            </span>
            <ShareButton
              title={`${vehicle.make} ${vehicle.model} - ${vehicle.version}`}
              text="Da uma olhada nesse veículo incrível que encontrei no Click Autos!"
              onShare={handleShareEvent}
            />
          </div>
        </div>
        <h2 className="mt-0 mb-[4px] font-bold text-[1.75rem] relative text-start sm:text-end">
          {new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            maximumFractionDigits: 0,
          }).format(vehicle.price as number)}
        </h2>
      </div>
    </div>
  );
};
